import { Copy } from 'lucide-react'
import { toast } from 'sonner'
import { Button } from '@/components/ui/button'
import { useCopyPayload, extractErrorMessage } from '@/queries/ticketMutations'

// Staff-only export button for the tracker detail view. Gating on "staff"
// happens where this is mounted (TrackerDetailView, via isAdminViewer against
// the ticket's own viewerRelation) — this component assumes it's only ever
// rendered for an admin viewer and just does the fetch-copy-toast.
export function CopyForClaude({ ticketId }: { ticketId: string }) {
  const copyPayload = useCopyPayload(ticketId)

  const handleClick = async () => {
    // Checked up front, before spending a call on the payload fetch (which
    // presigns attachment URLs — see useCopyPayload): an insecure/unsupported
    // context leaves navigator.clipboard undefined, and calling .writeText on
    // that throws a raw TypeError whose message means nothing to the user.
    if (typeof navigator.clipboard?.writeText !== 'function') {
      toast.error('Clipboard unavailable in this browser context')
      return
    }
    try {
      const { text } = await copyPayload.mutateAsync()
      await navigator.clipboard.writeText(text)
      toast.success('Copied for Claude / ChatGPT')
    } catch (err) {
      toast.error(extractErrorMessage(err, 'Could not copy ticket'))
    }
  }

  return (
    <Button size="xs" variant="outline" disabled={copyPayload.isPending} onClick={handleClick}>
      <Copy className="h-3 w-3" />
      {copyPayload.isPending ? 'Copying…' : 'Copy for Claude'}
    </Button>
  )
}
